export default {"src":"/_next/static/media/ceca-logo-blanco.51544073.svg","height":37,"width":142};